import React from 'react';
import { cn } from '@/lib/utils';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  label?: string;
  noBorder?: boolean;
}

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, children, label, noBorder = false, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(
          "relative",
          !noBorder && "border-b-2 border-neutral-950 dark:border-neutral-100",
          className
        )}
        {...props}
      >
         {label && (
             <div className="absolute top-0 left-0 p-2 font-mono text-xs text-muted-foreground border-b border-r border-neutral-950 dark:border-neutral-100">
                {label}
            </div>
         )}
        {children}
      </section>
    );
  }
);
Section.displayName = "Section";
